import { useEffect, useState } from "react";
import { BASE_URL } from "../api/apiClient";

// const BASE_URL = "https://api.avexa.net"; // adjust if your care-journey endpoint lives on a different base than clinic-onboarding

/**
 * Fetches the Find Care journey's content JSON (copy, options, labels) for a
 * given clinic slug, so content can be edited per-clinic without a redeploy.
 * Falls back to whatever the caller passes as `fallback` (the static JSON)
 * while loading or if the fetch fails, so screens never render on undefined.
 */
export function useCareJourneyContent(clinicSlug = "femcare") {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);

    const fetchContent = async () => {
      try {
        const res = await fetch(`${BASE_URL}/api/femcare/care-journey/?clinic=femcare`);
        if (!res.ok) throw new Error("Failed to fetch care journey content");
        const data = await res.json();
        if (!cancelled) setContent(data);
      } catch (err) {
        if (!cancelled) setError(err.message);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchContent();
    return () => {
      cancelled = true;
    };
  }, [clinicSlug]);

  return { content, loading, error };
}